import './view-nav-button.scss';
import { h } from 'preact';

export default function ViewNavButton({ id, name, shapes, isSelected, backgroundImageThumb, onClick, isCompact }) {
	function handleClick() {
		if (typeof onClick === 'function') {
			onClick(id);
		}
	}

	return (
		<button class={'view-nav-button' + (isSelected ? ' is-selected' : '') + (isCompact ? ' is-compact' : '')} onClick={handleClick}>
			<div class="view-nav-button-view-thumbnail-wrapper">
				<div class="view-nav-button-view-thumbnail-container">
					<img src={backgroundImageThumb.src} />
				</div>
				<span class="view-nav-button-view-view-thumbnail-container-plot-number-count">{shapes.length}</span>
			</div>
			<div class="view-nav-button-name">
				{name}
			</div>
		</button>
	);
}
